import React from 'react';
import { IntlProvider } from 'react-intl';
import GlobalStyle from './configs/global-styles';
import Subcontractor from './container/sub-profile';

const RenderWithIntl = component => (
  <IntlProvider locale="en" timeZone="America/New_York" {...component} />
);

const App = () => (
  <>
    <GlobalStyle />
    <RenderWithIntl>
      <Subcontractor />
    </RenderWithIntl>
  </>
);

export default App;
